module.exports = __webpack_public_path__ + "img/shopping-experiences.f3bd7479.jpg";